<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oMhXyD/tc-custom/9781401689414.jpg?1703822509312" alt="This image is the cover for the book Perfect Secret, Amish Wedding Novellas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Perfect Secret, Amish Wedding Novellas
      </h1>
      <p class="bookDescription body article font2">
        <p>Nineteen-year-old Rose Bender is a bridal attendant for Priscilla King’s upcoming wedding and has recently become engaged to handsome but sober, Luke Lantz. Rose and Luke have known each other since childhood and their families have both joked about a possible union in recent years.</p><p>When Luke asks her to marry him, Rose agrees out of a sense of duty and a willingness to settle for solid friendship as a basis for the engagement. But, as she witnesses Priscilla’s excitement, despite a trail of mishaps leading to the wedding, Rose begins to wonder if there shouldn’t be more to a relationship.</p><p>Rose begins to examine Luke and his life more closely, and she’s amazed when she stumbles upon an exciting, secret side of him. But what if she isn’t as adventurous as Luke expects? The Lord will whisper to Rose and Luke that they both have much to offer that’s worth the telling in <i>A Perfect Secret.</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Long
      </h2>
      
      <p class="authorDescription body article"><P>Kelly Long is a nationally bestselling author of Amish Fiction who enjoys studying the Appalachian Amish in particular. Kelly was raised in North Central Pennsylvania, and her dad's friendship with the Amish helped shape Kelly's earliest memories of the culture. Today, she lives in Hershey, Pennsylvania, with her three children and is a great proponent of autism spectrum and mental health needs. Visit Kelly on Facebook: Fans-of-Kelly-Long and Twitter: @KellyLongAmish.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?441ec28c